<div class="wrapper {{type}}" *ngIf="type === 'error' ">

    <div class="info" *transloco="let t; prefix: 'studentNotificationModal'">

        <div class="title">

            <img src="assets/images/icons/notice.svg" alt="notice">
            Oops...
        </div>

        <div class="text" [innerHTML]=" t('message') " >
<!--            {{ t('message') }}-->
        </div>

    </div>


    <div class="btn-wrapper">

        <button type="button" class="btn dark-btn" (click)="openRequestModal('goToParent')">
            {{ 'studentNotificationModal.btn'|transloco }}
        </button>

        <!--        <div class="popup">-->
        <!--            Перейдіть в кабінет представника для вирішення питання-->

        <!--        </div>-->
    </div>


</div>

<div class="wrapper {{type}}" *ngIf="type!== 'error' ">

    <div class="info" *transloco="let t; prefix: 'studentNotificationModal'">

        <div class="title">

            <img src="assets/images/icons/notice.svg" alt="notice">
            {{ t('attention') }}
        </div>

        <div class="text" [innerHTML]="t('materials')" >
<!--            {{ t('materials') }}-->
        </div>

    </div>

</div>
